import * as React from "react";
import { StyledLoaderWrapper, StyledSpinner } from "./styles";

interface LoaderComponentProps {
  content?: string | undefined;
  children?: React.ReactNode;
  isRelative?: boolean;
}
export const LoaderComponent = ({
  content,
  children,
  isRelative,
}: LoaderComponentProps) => {
  return (
    <StyledLoaderWrapper
      style={{ position: isRelative ? "relative" : "absolute" }}
    >
      {children || <StyledSpinner />}

      {content && <p style={{ marginTop: 20 }}>{content}</p>}
    </StyledLoaderWrapper>
  );
};
